module.exports = {
      id: "arrow-circle-right-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#arrow-circle-right",
      toString: function () {
        return this.url;
      }
    }